import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

/**
* Init (binding button actions)
*/
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationMenu/Show?menuId=" + dataItem.MenuID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationMenu/Edit?menuId=" + dataItem.MenuID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this as kendo.ui.Grid;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as MenuGridVM;
        removeItem(dataItem.MenuID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function removeItem(menuId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationMenu/Delete"),
        data: {
            menuId: menuId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("MenuItemsGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}

